import {NgModule} from '@angular/core';
import {NewEquipmentModalComponent} from './equipment-modal.component';
import {CommonModule} from '@angular/common';
import {ModalModule} from '@components/modal/modal.module';
import {EquipmentDataService} from '../equipment-data.service';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {EquipmentSelectModule} from '@components/equipment-select/equipment-select.module';
import {ApparatusCardCommonModule} from '@subforms/apparatus-card-common/apparatus-card-common.module';
import {ApparatusCardCalibrationsModule} from '@subforms/apparatus-card-calibrations/apparatus-card-calibrations.module';
import {LayoutModule} from '@layoutComponents/layout.module';
import {ReactiveFormsModule} from '@angular/forms';
import {PipesModule} from '@pipes/pipes.module';
import {IconsModule} from '@lab365/icons';

@NgModule({
    imports: [
        CommonModule,
        ModalModule,
        FormFieldModule,
        EquipmentSelectModule,
        ApparatusCardCommonModule,
        ApparatusCardCalibrationsModule,
        LayoutModule,
        ReactiveFormsModule,
        PipesModule,
        IconsModule,
    ],
    exports: [
        NewEquipmentModalComponent,
    ],
    declarations: [
        NewEquipmentModalComponent,
    ],
    providers: [
        EquipmentDataService,
    ],
})
export class EquipmentModalModule {
}
